import { useState } from "react";
import { downloadBarcodeRedemption } from "../../../reducers/payouts.slice";

// Shared between MemberGiftCards and MemberMyGiftCards — both open the exact
// same three dialogs (reveal code, still processing, rejected) off a click
// on a purchased-card tile, using identical status branching.
export default function useGiftCardRedemption({ dispatch, showToast, companyConfig }) {
  const [selectedCard, setSelectedCard] = useState(null);
  const [openStoreCard, setOpenStoreCard] = useState(false);
  const [openCardProcessing, setOpenCardProcessing] = useState(false);
  const [openRejectedCard, setOpenRejectedCard] = useState(false);
  const [imageBase64, setImageBase64] = useState("");

  const openCard = async (card) => {
    const enrichedGiftCard = {
      ...card,
      ...(companyConfig[card?.gift_card_details?.retailer] || {
        logo: "/logos/default.png",
        bg: "#000000",
      }),
    };

    if (card?.status === "APPROVED" || card?.status === "PENDING_APPROVAL") {
      setSelectedCard(enrichedGiftCard);
      setOpenCardProcessing(true);
      return;
    }
    if (card?.status === "REJECTED") {
      setSelectedCard(enrichedGiftCard);
      setOpenRejectedCard(true);
      return;
    }

    const response = await dispatch(downloadBarcodeRedemption({ id: card?.id }));
    if (response?.error && Object.keys(response?.error)?.length > 0) {
      showToast(response?.error?.message, "error");
      return;
    }
    setImageBase64(
      response?.payload?.length === 0
        ? ""
        : `data:${response.payload[0]?.content_type};base64,${response.payload[0]?.document_bytes}`
    );
    setSelectedCard(enrichedGiftCard);
    setOpenStoreCard(true);
  };

  return {
    selectedCard,
    openStoreCard,
    openCardProcessing,
    openRejectedCard,
    imageBase64,
    openCard,
    closeStoreCard: () => setOpenStoreCard(false),
    closeProcessing: () => setOpenCardProcessing(false),
    closeRejected: () => setOpenRejectedCard(false),
  };
}
